import {
  type CoreActivitiesComponent,
  CORE_ACTIVITIES_NAME,
} from "@b2bportal/core-types";
import { useStyles } from "../context";

export const useActivitiesStyles = (
  componentName: keyof typeof CoreActivitiesComponent,
  defaultStyles?: object
) => {
  return useStyles(CORE_ACTIVITIES_NAME, componentName, defaultStyles);
};
